export default "__VITE_ASSET__Brr6FToA__"